import { FunctionComponent } from 'react'

import config from '@config'
import EmbeddedContent from '@components/EmbeddedContent'

const {
  socialembeds: { facebookStaticPageUrl },
} = config

interface FacebookComponentProps {
  url: string
}

const FacebookComponent: FunctionComponent<FacebookComponentProps> = ({
  url,
}) => <EmbeddedContent url={`${facebookStaticPageUrl}${url}`} />

export default FacebookComponent
